//React
import React, { useEffect, useState } from 'react';
//API
import { DeviceApi } from '../../apis/index';
//Material-UI
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import { Form } from 'react-bootstrap';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
//Components
import MyLoading from '../../components/Loading.js';

const useStyles = makeStyles({
  border: {
    background: 'rgb(63, 89, 140)',
    border: 0,
    borderRadius: 3,
    boxShadow: '0 0px 30px 30px rgba(0, 0, 0, 0)',
    color: '#FFFFFF',
    width: '100%',
    padding: '15px 30px',
    fontSize: '1.2rem',
  },

  divspace: {
    padding: '30px',
  },

  spacingTop: {
    marginTop: '25px',
    padding: '5px 15px',
    border: '2px solid',
  },

  boxcard: {
    paddingTop: '30px',
    width: '100%',
  },

  media: {
    height: 500,
  },

  formControl: {
    minWidth: 120,
  },
});

const DeviceUpdate = (props) => {
  const classes = useStyles();
  const id = props.match.params.id;
  const [device, setDevice] = useState({ useYn: '', approveYn: '' });
  const [hospital, setHospital] = useState([]);
  const [deviceModel, setDeviceModel] = useState('');
  const [hospitalSelect, setHospitalSelect] = useState('');

  const [loading, setLoading] = useState(false);

  const getDeviceDetail = async () => {
    const res = await DeviceApi.getDeviceID(id);
    const res1 = await DeviceApi.getDeviceHospital(id);
    setHospital(res1.data ? res1.data.name : null);
    // setHospital(res1.data);

    setDevice({
      ...res.data,
      useYn: res.data.useYn.toString(),
      approveYn: res.data.approveYn.toString(),
    });
    if (res.data.deviceId === 'iPad8,9') {
      setDeviceModel('iPad Pro 2nd');
    } else if (res.data.deviceId === 'iPad13,4') {
      setDeviceModel('iPad Pro 3rd');
    } else if (res.data.deviceId === 'iPad14,3') {
      setDeviceModel('iPad Pro 4th');
    } else if (res.data.deviceId === 'iPad16,3') {
      setDeviceModel('iPad Pro 5th');
    } else {
      setDeviceModel(res.data.deviceId);
    }
  };

  useEffect(() => {
    getDeviceDetail();
  }, []);

  const updateDevice = async () => {
    const formData = new FormData();
    formData.append('uid', id);
    formData.append('approveYn', device.approveYn);
    formData.append('useYn', device.useYn);
    formData.append('hospitalId', hospitalSelect);
    formData.append('memo', device.memo);
    formData.append('rejectReason', device.rejectReason);
    formData.append('serialNumber', device.serialNumber);
    formData.append('uniqueId', device.uniqueId);

    setLoading(true);
    const res = await DeviceApi.updateDevice(id, formData);
    if (res.statusCode === 200) {
      props.history.push('/Device');
    } else {
      setLoading(false);
      alert(res.statusCode + '\n' + res.message);
    }
  };

  const changeValue = (e) => {
    setDevice({
      ...device,
      [e.target.name]: e.target.value,
    });
  };

  const disconnectDevice = async () => {
    setLoading(true);
    const res = await DeviceApi.disconnectDevice(id);
    if (res.statusCode === 200) {
      setLoading(false);
      alert('연결 해제 완료');
      window.location.reload();
    } else {
      setLoading(false);
      alert(res.statusCode + '\n' + res.message);
    }
  };

  const setDate = (utcDate) => {
    const date = new Date(utcDate);
    date.setHours(date.getHours() + 9);
    return date.toISOString().replace('T', ' ').substring(0, 19);
  };

  return (
    <>
      <div className={classes.root}>
        <Grid container direction="row" alignItems="center">
          <Box className={classes.border}>Device Info</Box>
        </Grid>
        <div className={classes.divspace}>
          <Grid
            container
            direction="row"
            justifyContent="space-around"
            alignItems="center"
            className={classes.grid}
          >
            <Grid xs={5}>
              <Form.Label>Device UniqueID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Device UniqueID"
                name="uniqueId"
                value={device ? device.uniqueId : ''}
                onChange={changeValue}
                disabled
              />
            </Grid>
            <Grid xs={3}>
              <Form.Label>Device Model</Form.Label>
              <Form.Control
                type="text"
                placeholder="Device ID"
                name="name"
                value={deviceModel}
                disabled
              />
            </Grid>
            <Grid xs={3}>
              <Form.Label>Device SerialNumber</Form.Label>
              <Form.Control
                type="text"
                placeholder="Device SerialNumber"
                name="serialNumber"
                value={device ? device.serialNumber : ''}
                onChange={changeValue}
              />
            </Grid>
          </Grid>
        </div>

        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <Box className={classes.border}>Device History</Box>
        </Grid>
        <div className={classes.divspace}>
          <Grid
            container
            direction="row"
            justifyContent="space-around"
            alignItems="center"
            className={classes.grid}
          >
            <Grid item xs={12} sm={12}>
              <Form.Label style={{ margin: '0px 0px 2px 0px' }}>
                Device Manage Memo
              </Form.Label>
              <Form.Control
                style={{ minHeight: '40px', maxHeight: '150px' }}
                as="textarea"
                type="text"
                rows={3}
                placeholder="Device Manage Memo"
                name="memo"
                value={device ? device.memo : ''}
                onChange={changeValue}
              />
            </Grid>
          </Grid>
        </div>
        <div style={{ display: 'flex' }}>
          <Form.Group style={{ marginRight: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Insert Date</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {device.insertDate && (
                <div>{setDate(device.insertDate)} (KST)</div>
              )}
            </div>
          </Form.Group>
          <Form.Group style={{ marginLeft: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Insert ID</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {device.insertId}
            </div>
          </Form.Group>
        </div>
        <div style={{ display: 'flex' }}>
          <Form.Group style={{ marginRight: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Modify Date</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {device.insertDate && (
                <div>{setDate(device.modifyDate)} (KST)</div>
              )}
            </div>
          </Form.Group>
          <Form.Group style={{ marginLeft: '20px', width: '50%' }}>
            <Form.Label style={{ fontWeight: 'bold' }}>Modify ID</Form.Label>
            <div
              style={{
                border: '1px solid #3F598C',
                borderRadius: '5px',
                padding: '10px 0px 10px 10px',
                background: '#DADADA',
                minHeight: '40px',
              }}
            >
              {device.modifyId}
            </div>
          </Form.Group>
        </div>
        <Grid>
          <Box className={classes.border}>Device YN</Box>
          <div className={classes.divspace}>
            <Grid
              container
              direction="row"
              justifyContent="space-around"
              alignItems="center"
            >
              <Grid>
                <FormControl component="fieldset">
                  <FormLabel component="legend">USE YN</FormLabel>
                  <RadioGroup
                    aria-label="gender"
                    name="useYn"
                    value={device ? device.useYn : ''}
                    onChange={changeValue}
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio />}
                      label="true"
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio />}
                      label="false"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid>
                <Form.Label>Device Reject Reason</Form.Label>
                <Form.Control
                  style={{ width: '800px', minHeight: 40, maxHeight: '150px' }}
                  as="textarea"
                  type="text"
                  rows={3}
                  placeholder="Device Reject Reason"
                  name="rejectReason"
                  value={device ? device.rejectReason : ''}
                  onChange={changeValue}
                />
              </Grid>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'ceneter',
                }}
              >
                <button
                  style={{
                    border: hospital ? '1px solid #000' : '1px solid #ccc',
                    borderRadius: '5px',
                    padding: '5px',
                  }}
                  disabled={hospital ? false : true}
                  onClick={disconnectDevice}
                >
                  병원 연결 끊기
                </button>
                <div style={{ marginTop: '10px' }}>
                  연결된 병원: {hospital ? hospital : '없음'}
                </div>
              </div>
            </Grid>
          </div>
        </Grid>

        <Grid>
          <Box className={classes.border}>Calibration Info</Box>
          <div className={classes.divspace}>
            <Grid
              container
              direction="row"
              justifyContent="space-around"
              alignItems="center"
            >
              <Grid item xs={12} sm={12}>
                <Form.Label style={{ margin: '12px 0px 2px 0px' }}>
                  Calibration Data
                </Form.Label>
                <Form.Control
                  as="textarea"
                  type="text"
                  rows={3}
                  placeholder="Empty"
                  style={{
                    width: '100%',
                    minHeight: '40px',
                    maxHeight: '150px',
                  }}
                  name="calibrationData"
                  value={device ? device.calibrationData : ''}
                  onChange={changeValue}
                  disabled
                />
              </Grid>
            </Grid>
          </div>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <Grid>
            <button
              onClick={() => {
                props.history.goBack();
              }}
            >
              Back
            </button>
          </Grid>
          <Grid>
            <button color="primary" onClick={updateDevice}>
              Update
            </button>
          </Grid>
        </Grid>
      </div>
      {loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <MyLoading />
        </div>
      )}
    </>
  );
};

export default DeviceUpdate;
